import Image from 'app/Components/Shared/Image/image';
import React, { useState, useEffect, useRef, useCallback } from 'react';
import Config from '../../../Config';
import { prepareUrl } from '../../../utilities/StringHelpers/StringHelpers.js';
import { gaEvent } from '../../../utilities/analytics/tracking';
import { BtnSubmit } from '../../Shared/Buttons/BtnSubmit';
import { isBrowser, isMobile } from 'react-device-detect';
import PopUp from '../../Shared/Popup/PopUp';


const VideoPopUpBlock = ({ propsIContent }) => {
    useEffect(() => {
        setSelectedTab(propsIContent.popupItemsList?.expandedValue[0])
    }, []);

    //POPUP
    const [popUpFlag, setPopUpFlag] = useState(false);
    const [selectedTab, setSelectedTab] = useState(null);

    const epiBaseUrl = Config?.epiBaseUrl;
    const title = propsIContent.mainTitle?.value;
    const textLink = propsIContent.textLink?.value;
    const backGroundImage = epiBaseUrl + propsIContent.backGroundImage.value?.url;
    const backGroundColor = propsIContent.backgroundImageVideoPopup?.value;
    const iconImage = epiBaseUrl + propsIContent.iconTextLink?.value.url;

    const googleAnalytics = (params) => {
        gaEvent(
            params.category,
            params.eventType,
            params.status
        );
    }
    const onClick = () => {
        setPopUpFlag(true)
        return
        googleAnalytics({ category: 'home_page_strip', eventType: 'click', status: item.name })

    };
    const changeSelectedTab = (item) => {
        if (item.name != selectedTab.name) {
            setSelectedTab(item)
        }
    };
    const closeModal = () => {
        setPopUpFlag(false)
        return

    };

    return (
        <>
            <div id={propsIContent.idToScroll?.value} className='video-popup-block-header' style={{
                backgroundColor: backGroundColor,
                backgroundImage: `url("${backGroundImage}")`
            }}>
                <div className='video-popup-block-title' dangerouslySetInnerHTML={{ __html: title }}></div>
                <div className='video-popup-block-link' onClick={() => onClick()}>
                    <span><Image src={iconImage} /></span>
                    <span>{textLink}</span>
                </div>
            </div>

            <div className='video-popup-block-popup-container' >
                <PopUp
                    className={'video-popup-block-popup'}
                    showPopUp={popUpFlag}
                    onClose={() => closeModal()}>
                    {<>

                        <div className='video-popup-block-popup-body'>

                            <div className='video-popup-block-popup-title'>
                                {propsIContent.popupItemsList.expandedValue?.map((item, index) => (
                                    <span className={`video-popup-block-popup-title-item ${selectedTab?.name == item?.name ? "selectedTab" : ""}`} onClick={() => changeSelectedTab(item)} key={index}>{item.titlePopupItem?.value}</span>
                                ))}

                            </div>
                            <div className='video-popup-block-popup-video'>
                                {selectedTab?.videoFile?.value?.url &&
                                    <video src={epiBaseUrl + selectedTab?.videoFile?.value?.url} poster={''} autoPlay={false} playsInline muted={false} loop controls={true} />
                                }
                                {selectedTab?.youTubeLink?.value &&
                                    <iframe width="100%" height="300" src={selectedTab?.youTubeLink?.value} title="YouTube video player" frameborder="0" allow="accelerometer; autoplay; clipboard-write; encrypted-media; gyroscope; picture-in-picture; web-share" allowfullscreen></iframe>
                                }
                            </div>

                        </div>


                    </>}
                </PopUp>
            </div>
        </>
    );
};
export default VideoPopUpBlock;